package fr.labodoc.healthProfessional.webApp.data.model

data class UniversityHospitalModel(
  val id: String,
  val name: String,
  val department: Department
) {
  data class Department(
    val code: String,
    val name: String
  )
}
